"use strict";

/**
 * Retrieve and safely parse a JSON value from localStorage.
 * Removes the key if parsing fails, preventing corrupt data from persisting.
 *
 * @param {string} key - Storage key to read.
 * @param {*} defaultValue - Value returned when the key is missing or invalid.
 * @returns {*} Parsed value or the provided defaultValue.
 */
export function getLocalStorageItem(key, defaultValue) {
    let raw;
    try {
        raw = localStorage.getItem(key);
        return raw ? JSON.parse(raw) : defaultValue;
    } catch (error) {
        console.error(`Failed to parse localStorage item "${key}". Resetting.`, error);
        if (raw !== null && raw !== undefined) {
            localStorage.setItem(`${key}::automatic-backup-on-error`, raw);
        }
        localStorage.removeItem(key);
        return defaultValue;
    }
}


const USER_INFO_KEY = "userInfo";
const PROJECT_FILE_KEY = "projectFile";

export function getStoredUserInfo(defaultValue = null) {
    return getLocalStorageItem(USER_INFO_KEY, defaultValue);
}

export function setStoredUserInfo(userInfo) {
    localStorage.setItem(USER_INFO_KEY, JSON.stringify(userInfo));
}

export function clearStoredUserInfo() {
    localStorage.removeItem(USER_INFO_KEY);
}

export function getStoredProjectFile(defaultValue = null) {
    return getLocalStorageItem(PROJECT_FILE_KEY, defaultValue);
}

export function setStoredProjectFile(projectFile) {
    localStorage.setItem(PROJECT_FILE_KEY, JSON.stringify(projectFile));
}

export function clearStoredProjectFile() {
    localStorage.removeItem(PROJECT_FILE_KEY);
}
